import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
// WHY: an empty name term is the existence probe for "with no bundle" — pruned as empty it becomes match-ALL.
const isCollectionExistenceProbe = (key, value)=>key === 'name' && value != null && typeof value === 'object' && Object.values(value).includes('');
const isEmptyPredicate = (value)=>{
    if (value == null) return true;
    if (typeof value === 'string') return value.length === 0;
    if (typeof value === 'boolean' || typeof value === 'number') return false;
    if (Array.isArray(value)) return value.every(isEmptyPredicate);
    if (typeof value === 'object') {
        return Object.entries(value).every((param)=>{
            let [key, entry] = param;
            return !isCollectionExistenceProbe(key, entry) && isEmptyPredicate(entry);
        });
    }
    return false;
};
const narrowsSearch = (key, value)=>!isEmptyPredicate({
        [key]: value
    });
export const hasActiveFilter = (filter)=>Object.entries(filter).some((param)=>{
        let [key, value] = param;
        return key !== 'version' && narrowsSearch(key, value);
    });
const pruneValue = (value)=>{
    if (Array.isArray(value)) return value.map(pruneValue).filter((entry)=>!isEmptyPredicate(entry));
    if (value != null && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).filter((param)=>{
            let [key, entry] = param;
            return narrowsSearch(key, entry);
        }).map((param)=>{
            let [key, entry] = param;
            return [
                key,
                isCollectionExistenceProbe(key, entry) ? entry : pruneValue(entry)
            ];
        }));
    }
    return value;
};
export const pruneEmptyPredicates = (filter)=>_object_spread_props(_object_spread({}, pruneValue(filter)), {
        version: filter.version
    });
export const isUserDrivenNarrowing = (param)=>{
    let { filter, lastQuery, filterEditedSinceLastSearch } = param;
    return filter != null && (filterEditedSinceLastSearch || lastQuery.length > 0) && hasActiveFilter(filter);
};
